module.exports = __webpack_public_path__ + "media/src/assets/Images/DeleteFilled-d50eabfde7f9f1516a5405097c043511.svg";